import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: 'Ava Thompson',
        title: 'Event Director',
        biography: "Ava Thompson brings a visionary perspective to event planning as an accomplished Event Director. With over a decade of leadership experience, she excels in overseeing large-scale events from concept to execution. Ava is known for her creativity, leadership, and ability to deliver high-impact events that align with client goals.",
        contacts: {
            phone: '333-444-5566',
            email: 'ava.thompson@example.com',
            website: 'www.avathompson.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            'Directed multiple international conferences and expos',
            'Expert in creative event concepts and branding',
            'Strong leadership in cross-functional event teams',
            'Specialist in stakeholder engagement and VIP management',
            'Renowned for turning visions into memorable realities',
        ],
        skills: [
            { id: 1, title: 'Strategic Planning', progress: 93 },
            { id: 2, title: 'Leadership & Supervision', progress: 91 },
            { id: 3, title: 'Creative Direction', progress: 88 },
        ],
    },
    {
        id: 2,
        image: images.team2,
        name: 'Liam Walker',
        title: 'Operations Manager',
        biography: "Liam Walker is a results-driven Operations Manager known for streamlining event processes and ensuring operational excellence. With a strong background in logistics and workflow optimization, Liam ensures that every detail behind the scenes runs smoothly, contributing to the flawless execution of events.",
        contacts: {
            phone: '444-555-6677',
            email: 'liam.walker@example.com',
            website: 'www.liamwalker.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            'Managed operations for major conferences and exhibitions',
            'Expert in logistics, resource allocation, and timelines',
            'Developed systems to improve event setup efficiency',
            'Strong background in risk assessment and compliance',
            'Trusted for reliability and problem-solving under pressure',
        ],
        skills: [
            { id: 1, title: 'Logistics Management', progress: 92 },
            { id: 2, title: 'Process Optimization', progress: 89 },
            { id: 3, title: 'Risk Management', progress: 86 },
        ],
    },
    {
        id: 3,
        image: images.team3,
        name: 'Chloe Martin',
        title: 'Head of Marketing',
        biography: "Chloe Martin is a dynamic marketing leader with a flair for promoting events through innovative and data-driven strategies. Her expertise spans digital campaigns, branding, and audience engagement, making her instrumental in building strong event presence and driving attendance.",
        contacts: {
            phone: '555-666-7788',
            email: 'chloe.martin@example.com',
            website: 'www.chloemartin.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            'Led marketing strategies for large-scale public events',
            'Expert in digital marketing, SEO, and social media',
            'Increased event registration through targeted campaigns',
            'Skilled in brand positioning and public relations',
            'Known for high-impact content and audience conversion',
        ],
        skills: [
            { id: 1, title: 'Digital Marketing', progress: 94 },
            { id: 2, title: 'Brand Strategy', progress: 90 },
            { id: 3, title: 'Audience Engagement', progress: 88 },
        ],
    },
    {
        id: 4,
        image: images.team4,
        name: 'Noah Patel',
        title: 'Tech Lead',
        biography: "Noah Patel is a technology expert dedicated to delivering seamless digital experiences at events. As Tech Lead, he specializes in integrating AV systems, live streaming, event apps, and other tech solutions that enhance both onsite and virtual event experiences.",
        contacts: {
            phone: '666-777-8899',
            email: 'noah.patel@example.com',
            website: 'www.noahpatel.com',
        },
        accounts: {
            facebook: "",
            linkedin: "",
            twitter: "",
            instagram: ""
        },
        experience: [
            'Implemented tech systems for hybrid and virtual events',
            'Expert in event apps, registration systems, and live streaming',
            'Managed audiovisual setups and IT infrastructure',
            'Ensured cybersecurity and data protection at events',
            'Known for rapid troubleshooting and technical support',
        ],
        skills: [
            { id: 1, title: 'AV & Streaming Tech', progress: 93 },
            { id: 2, title: 'Event Software Integration', progress: 90 },
            { id: 3, title: 'IT Support & Security', progress: 87 },
        ],
    }
];

export default team;